import { ScktResumeMarketService } from './../../services/webFeeder/sckt-resume-market.service';
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Constants } from '@utils/constants';
import { WorkspaceNewService } from '@services/workspace-new.service';
import { AbstractItem } from '@business/base/abstract-item';
import { MatDialog } from '@angular/material/dialog';
import { AbstractItemService } from '@business/base/abstract-item.service';
import { Subscription , of } from 'rxjs';
import { AppUtils } from '@utils/app.utils';
import { ConfigService } from '@services/webFeeder/config.service';

@Component({
  selector: Constants.WINDOW_NAME_HIGH_LOW_DAY,
  templateUrl: './high-low-day.component.html'
})
export class HighLowDayComponent extends AbstractItem implements OnInit, OnDestroy {


  @Input() data: any;
  title = Constants.TITLE_CARD_HIGH_LOW_DAY;
  newWindow = false;
  index = 0;
  windowActive: any;
  channelId: number;
  tabChange: any;
  msgNoData = Constants.WORKSPACE_MSG018;
  private subscriptionResumeMarket: Subscription;
  list: any[];
  subscribeType: any;
  showExpandCard = this.configService.getShowExpandCard(Constants.WINDOW_NAME_HIGH_LOW_DAY);
  removeFromWksTooltip = Constants.TOOLTIP_REMOVE_WKS_TOOL;

  constructor(
    _dialog: MatDialog,
    _workspaceService: WorkspaceNewService,
    _itemService: AbstractItemService,
    private _resumeMarketService: ScktResumeMarketService,
    private configService: ConfigService
  ) {
    super(_workspaceService, _dialog, _itemService);
    this.workspaceService = _workspaceService;
    this.dialog = _dialog;
    this.subscribeType = this.getSubscribeType(this.index);
    this.changeTab(null);
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.subscriptionResumeMarket) {
      this.subscriptionResumeMarket.unsubscribe();
    }
    this._resumeMarketService.unsubscribeResumeMarket(this.subscribeType.service, Constants.INDEX_HIGH_LOW_DAY);
    this.closeSheet();
  }

  getSubscribeType(index: number) {
    return Constants.SERVICE_HIGH_LOW_DAY.find(x => x.index === index);
  }

  changeTab($event) {
    if ($event && this.subscribeType && $event.index >= 0 && this.subscribeType.index !== $event.index) {
      this._resumeMarketService.unsubscribeResumeMarket(this.subscribeType.service, Constants.INDEX_HIGH_LOW_DAY);
      this.index = $event.index;
      this.list = [];
      this.subscribeType = this.getSubscribeType(this.index);
    }
    if (this.index >= 0 && this.subscribeType) {
      setTimeout(() => {
        this.getList();
      }, 0);
    }
  }

  getList() {
    this._resumeMarketService.subscribeResumeMarket(this.subscribeType.service, Constants.INDEX_HIGH_LOW_DAY);
    this.subscriptionResumeMarket = this._resumeMarketService.messagesResumeMarket
      .subscribe((msg: any) => {
        if (msg && msg.list) {
          if (msg.identifier === this.subscribeType.identifier) {
            this.list = [];
            for (let i = 0; i < 6 && msg.list.L.length > i; i++) {
              if (this.index === 0) {
                this.list.push({
                  pos: i + 1,
                  quote: msg.list.L[i].Q,
                  priceFormat: msg.list.L[i].P ? AppUtils.convertToCurrencyString(msg.list.L[i].P) : '0',
                  value: AppUtils.numberToFormattedNumber(msg.list.L[i].V),
                  valueColor: msg.list.L[i].V,
                  volumeFinancier: AppUtils.convertNumberToOptimizedNumber(msg.list.L[i].VF)
                });
              } else {
                this.list.push({
                  pos: i + 1,
                  quote: msg.list.L[i].Q,
                  priceFormat:  msg.list.L[i].P ? AppUtils.convertToCurrencyString(msg.list.L[i].P) : '0',
                  value: AppUtils.numberToFormattedNumber(msg.list.L[i].C),
                  valueColor: msg.list.L[i].C,
                  volumeFinancier: AppUtils.convertNumberToOptimizedNumber(msg.list.L[i].VF)
                });
              }
            }
          }
        }
      });
  }

  openNewWindow() {
    const options = 'width=300px, height=300px';
    const parameters = '?index=' + this.index;
    if (this.windowActive == null || this.windowActive.closed) {
      super.getNewWindow(Constants.WINDOW_NAME_HIGH_LOW_DAY, parameters, options, this.data.id)
        .subscribe(window => {
          this.windowActive = window;
        });
    } else {
      this.windowActive.focus();
    }
  }

  closeSheet() {
    if (this.windowActive != null) {
      this.windowActive.close();
    }
  }

}
